document.addEventListener('DOMContentLoaded', () => {

  // --- Helper: Get minimum quantity from product tags ---
  const getMinQtyFromTags = (tagsString) => {
    const tags = tagsString?.split(',') || [];
    for (const tag of tags) {
      if (tag.trim().startsWith('min-')) {
        const num = parseInt(tag.replace('min-', '').trim());
        if (!isNaN(num)) return num;
      }
    }
    return 1;
  };

  // --- Enforce minimum quantity on quantity input ---
  const enforceMinQty = (qtyInput, minusBtn, minQty) => {
    if (!qtyInput) return;
    let currentQty = parseInt(qtyInput.value) || minQty;
    if (currentQty < minQty) currentQty = minQty;
    qtyInput.value = currentQty;

    if (minusBtn) {
      if (currentQty <= minQty) minusBtn.setAttribute('disabled', 'true');
      else minusBtn.removeAttribute('disabled');
    }
  };

  // --- Handle add-to-cart forms (product page & quick add) ---
  const handleProductForm = (form) => {
    const qtyInput = form.querySelector('input[name="quantity"]') || form.querySelector('input[type="number"]');
    const minusBtn = form.querySelector('button[name="minus"]') || form.querySelector('.quantity__button--minus');
    const plusBtn = form.querySelector('button[name="plus"]') || form.querySelector('.quantity__button--plus');
    const addBtn = form.querySelector('button[type="submit"]') || form.querySelector('.add-to-cart');
    const tags = form.dataset.productTags || '';
    const minQty = getMinQtyFromTags(tags);

    if (qtyInput) {
      if (!qtyInput.value || parseInt(qtyInput.value) < minQty) qtyInput.value = minQty;

      qtyInput.addEventListener('input', () => enforceMinQty(qtyInput, minusBtn, minQty));
      if (minusBtn) minusBtn.addEventListener('click', () => setTimeout(() => enforceMinQty(qtyInput, minusBtn, minQty), 50));
      if (plusBtn) plusBtn.addEventListener('click', () => setTimeout(() => enforceMinQty(qtyInput, minusBtn, minQty), 50));
    }

    if (addBtn && !qtyInput) {
      addBtn.addEventListener('click', (e) => {
        e.preventDefault();
        let productId = form.querySelector('input[name="id"]')?.value;
        const component = addBtn.closest('add-to-cart-component');
        if (!productId && component) productId = component.dataset.productId;
        if (!productId) return;

        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const existingItem = cart.items.find(item => item.id == productId);
            const newQty = existingItem ? existingItem.quantity + minQty : minQty;

            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: productId, quantity: newQty })
            });
          })
          .then(res => res.json())
          .then(() => document.dispatchEvent(new CustomEvent('cart:updated')))
          .catch(err => console.error(err));
      });
    }

    if (form && qtyInput) {
      form.addEventListener('submit', (e) => {
        if (parseInt(qtyInput.value) < minQty) qtyInput.value = minQty;
      });
    }
  };

  // --- Handle cart item minimums for both drawer and full cart page ---
  const handleCartItem = (row) => {
    const qtyInput = row.querySelector('input[name="updates[]"]') || row.querySelector('input[type="number"]');
    const minusBtn = row.querySelector('button[name="minus"]') || row.querySelector('.quantity__button--minus');
    const plusBtn = row.querySelector('button[name="plus"]') || row.querySelector('.quantity__button--plus');
    const tags = row.dataset.productTags || '';
    const minQty = getMinQtyFromTags(tags);

    if (!qtyInput || !minusBtn || !plusBtn) return;

    const update = () => {
      let currentQty = parseInt(qtyInput.value) || minQty;
      if (currentQty < minQty) currentQty = minQty;
      qtyInput.value = currentQty;

      if (currentQty <= minQty) minusBtn.setAttribute('disabled', 'true');
      else minusBtn.removeAttribute('disabled');
    };

    update();

    qtyInput.addEventListener('input', update);
    minusBtn.addEventListener('click', () => setTimeout(update, 50));
    plusBtn.addEventListener('click', () => setTimeout(update, 50));
  };

  // --- Initialize all forms and cart items ---
  document.querySelectorAll('[data-type="add-to-cart-form"], add-to-cart-component').forEach(handleProductForm);
  document.querySelectorAll('li.cart-item[data-product-tags], tr.cart-item[data-product-tags]').forEach(handleCartItem);

  // --- Observe DOM changes for cart drawer & full cart page updates ---
  const observer = new MutationObserver(() => {
    document.querySelectorAll('li.cart-item[data-product-tags], tr.cart-item[data-product-tags]').forEach(handleCartItem);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // --- Refresh product form min enforcement after cart updates ---
  document.addEventListener('cart:updated', () => {
    document.querySelectorAll('[data-type="add-to-cart-form"]').forEach(form => {
      const qtyInput = form.querySelector('input[name="quantity"]') || form.querySelector('input[type="number"]');
      const minusBtn = form.querySelector('button[name="minus"]') || form.querySelector('.quantity__button--minus');
      const minQty = getMinQtyFromTags(form.dataset.productTags || '');
      enforceMinQty(qtyInput, minusBtn, minQty);
    });
  });

});
